import React from 'react';
import PropTypes from 'prop-types';
import { submit } from 'redux-form';
import { connect } from 'react-redux';

import Button from '../../../../../Button';
import { FORMS } from '../../../../../../constants';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
  onSubmitRegistrationForm: PropTypes.func.isRequired,
};

export const StepOne = props => {
  const { onSubmitRegistrationForm } = props;

  const handleClick = () => {
    onSubmitRegistrationForm();
  };

  return (
    <Button variant="contained" color="primary" onClick={handleClick}>
      Confirm Details
    </Button>
  );
};

StepOne.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onSubmitRegistrationForm: () => dispatch(submit(FORMS.REGISTRATION_LONG)),
});

export default connect(
  null,
  mapDispatchToProps,
)(StepOne);
